var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import Button from '@material-ui/core/Button';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import Collapse from '@material-ui/core/Collapse';
import TableContainer from '@material-ui/core/TableContainer';
import makeStyles from '@material-ui/core/styles/makeStyles';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { useBaseI18n } from '../../hooks';
import Popup from '../Popup';
import GenericTableRow from './GenericTableRow';
export var mediaQuery = '@media screen and (min-width: 1600px)';
function GenericTable(_a) {
    var title = _a.title, _b = _a.displayColumns, displayColumns = _b === void 0 ? true : _b, editable = _a.editable, postUrl = _a.postUrl, rules = _a.rules, columns = _a.columns, initialValues = _a.initialValues, rs = _a.rows, deleteUrl = _a.deleteUrl, _c = _a.displayAddBtn, displayAddBtn = _c === void 0 ? true : _c, errorGenerator = _a.errorGenerator, setRows = _a.setRows, handlePost = _a.handlePost, onSubmit = _a.onSubmit, successMessageGenerator = _a.successMessageGenerator, requiredValues = _a.requiredValues, showMore = _a.showMore, disabledFields = _a.disabledFields, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.innerPopupClassName, innerPopupClassName = _e === void 0 ? '' : _e;
    var _f = useState(false), open = _f[0], setOpen = _f[1];
    var _g = useState(false), collapseOpen = _g[0], setCollapseOpen = _g[1];
    var _h = useState({ label: "", title: "", idx: -1 }), content = _h[0], setContent = _h[1];
    var classes = useGenericTableStyles();
    var genericTable = useBaseI18n(function (i18n) { return i18n.genericTable; });
    var rowsWithIndex = useMemo(function () {
        return rs.map(function (row, index) { return (__assign(__assign({}, row), { index: index })); });
    }, [rs]);
    var firstFive = useMemo(function () {
        if (!showMore)
            return rowsWithIndex;
        return rowsWithIndex.slice(0, 5);
    }, [rowsWithIndex, showMore]);
    var lastRows = useMemo(function () {
        if (!showMore)
            return [];
        return rowsWithIndex.slice(5);
    }, [rowsWithIndex]);
    var onClickEdit = function (mode, row, idx) {
        if (idx === void 0) { idx = -1; }
        setContent({ title: title, mode: mode, row: row, idx: idx });
        setOpen(function (prev) { return !prev; });
    };
    return (_jsxs(TableContainer, __assign({ className: classes.TableContainer + " " + className, component: Paper }, { children: [_jsxs(Table, __assign({ padding: "none", className: classes.table }, { children: [_jsx(TableHead, { children: _jsx(TableRow, { children: displayColumns && columns && columns.filter(function (elm) { return !elm.hidden; }).map(function (column, idx) { return (_jsx(MuiTableCell, __assign({ className: classes.TableCell, align: "left" }, { children: _jsxs("strong", { children: [column.title, "\u00A0"] }, void 0) }), idx)); }) }, void 0) }, void 0),
                    _jsx(TableBody, { children: firstFive.map(function (row) {
                            var _a;
                            return (_jsx(GenericTableRow, { row: row, index: row.index, columns: columns, editable: editable, onClickEdit: onClickEdit }, (_a = row.id) !== null && _a !== void 0 ? _a : row.index));
                        }) }, void 0)] }), void 0),
            showMore && (_jsx(Collapse, __assign({ "in": collapseOpen }, { children: _jsx(Table, __assign({ padding: "none", className: classes.table }, { children: _jsx(TableBody, { children: lastRows.map(function (row) {
                            var _a;
                            return (_jsx(GenericTableRow, { row: row, index: row.index, columns: columns, editable: editable, onClickEdit: onClickEdit }, (_a = row.id) !== null && _a !== void 0 ? _a : row.index));
                        }) }, void 0) }), void 0) }), void 0)),
            showMore && rs.length > 5 && (_jsx(Button, __assign({ color: "primary", variant: "text", onClick: function () { return setCollapseOpen(function (bool) { return !bool; }); }, classes: {
                    root: classes.showMoreButton,
                    label: classes.showMoreButtonLabel
                } }, { children: collapseOpen ? genericTable.showLess : genericTable.showAll }), void 0)),
            displayAddBtn && (_jsx(Button, __assign({ color: "primary", variant: "contained", startIcon: _jsx(AddCircleIcon, {}, void 0), className: classes.button, onClick: function () { return onClickEdit('add'); } }, { children: genericTable.addTitle + " " + title }), void 0)),
            open && (_jsx(Popup, { open: open, setPopup: setOpen, row: content.row, content: content, setContent: setContent, setRows: setRows, postUrl: postUrl, rules: rules, columns: columns, disabledFields: disabledFields, initialValues: initialValues, rows: rs, deleteUrl: deleteUrl, handlePost: handlePost, onSubmit: onSubmit, errorGenerator: errorGenerator, successMessageGenerator: successMessageGenerator, requiredValues: requiredValues, className: innerPopupClassName }, void 0))] }), void 0));
}
export default GenericTable;
export var useGenericTableStyles = makeStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f;
    return ({
        root: {
            width: 'auto',
            borderBottom: 'none',
            fontFamily: 'Assistant-Regular'
        },
        table: {
            direction: 'ltr'
        },
        button: (_a = {
                fontFamily: 'Assistant-Regular',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
                padding: ' 0 1.2%',
                borderRadius: '8px',
                margin: '1rem',
                height: '2rem',
                fontSize: '1rem'
            },
            _a[mediaQuery] = {
                padding: '1rem',
                fontSize: '1.35rem'
            },
            _a),
        showMoreButton: {
            display: 'box'
        },
        showMoreButtonLabel: (_b = {
                fontFamily: 'Assistant-Bold',
                textDecoration: 'underline',
                fontSize: '1rem'
            },
            _b[mediaQuery] = {
                fontSize: '1.35rem'
            },
            _b),
        TableCell: (_c = {
                color: theme.palette.primary.main,
                fontSize: '1.2rem',
                fontFamily: 'Assistant-Regular',
                padding: '0.1rem 1rem 1rem 0.1rem !important',
                borderBottom: 'none',
                margin: '0'
            },
            _c[mediaQuery] = {
                fontSize: '1.6rem'
            },
            _c),
        icons: (_d = {
                width: '25%',
                textAlign: 'right',
                borderBottom: 'none',
                padding: '0.1rem 0.1rem 1rem 0.1rem !important'
            },
            _d[mediaQuery] = {
                width: '10%'
            },
            _d),
        icon: (_e = {
                fontSize: '1.5rem'
            },
            _e[mediaQuery] = {
                fontSize: '2.025rem'
            },
            _e),
        TableContainer: (_f = {
                width: 'auto',
                padding: '2%'
            },
            _f[mediaQuery] = {
                padding: '2.7%'
            },
            _f),
        image: {
            width: '8vw'
        }
    });
});
//# sourceMappingURL=GenericTable.js.map